import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

// Wybór działów: input pełni podwójną rolę — po zamknięciu pokazuje podsumowanie wyboru,
// po otwarciu filtruje listę. Brak zaznaczeń oznacza dostęp do wszystkich działów.
export default class extends Controller {
  static targets = ["input", "menu", "row", "checkbox", "allCheckbox", "summary"]
  static values = {
    summaryTemplate: String,
    allHint: String,
  }

  connect() {
    useClickOutside(this)
    this.rows = this.rowTargets.map(row => ({ row, label: row.dataset.label.toLowerCase() }))
    this.refresh()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.inputTarget.readOnly = false
    this.inputTarget.value = ""
    this.filter()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.refresh()
  }

  clickOutside() {
    this.close()
  }

  filter() {
    const phrase = this.inputTarget.value.trim().toLowerCase()
    this.rows.forEach(({ row, label }) => {
      row.classList.toggle("hidden", !label.includes(phrase))
    })
  }

  // wiersz „Wszystkie działy" czyści wybór, bo pusty wybór = pełny dostęp;
  // refreshSummary sam odtwarza zaznaczenie tego wiersza
  toggleAll() {
    this.checkboxTargets.forEach(checkbox => { checkbox.checked = false })
    this.refreshSummary()
  }

  refresh() {
    this.inputTarget.readOnly = true
    this.refreshSummary()
  }

  refreshSummary() {
    const selected = this.checkboxTargets.filter(checkbox => checkbox.checked)
    this.allCheckboxTarget.checked = selected.length === 0

    if (selected.length === 0) {
      this.inputTarget.value = ""
      this.summaryTarget.textContent = this.allHintValue
      return
    }

    this.inputTarget.value = selected.map(checkbox => checkbox.dataset.label).join(", ")
    this.summaryTarget.textContent = this.summaryTemplateValue.replace("{selected}", selected.length)
  }
}
